





import { Component, Vue, Prop } from 'vue-property-decorator'
@Component<LanguageSelector>({})
export default class LanguageSelector extends Vue {
  locales = [
    { value: `de`, text: `Deutsch` },
    { value: `en`, text: `English` }
  ]
  public get locale() {
    return this.$i18n.locale
  }
  public set locale(locale: string) {
    this.$i18n.locale = locale
  }
}
